import * as React from 'react';
import type { ToastOptions } from './toast.types';

export interface ToastContextValue {
  toast: (options: ToastOptions) => void;
}

export const ToastContext = React.createContext<ToastContextValue | undefined>(undefined);

